import { CiCirclePlus } from "react-icons/ci";
import ContentLayout from "../components/layout/ContentLayout";
import SearchBar from "../components/SearchBar";
import { Link } from "react-router-dom";
import JournalCard from "../components/JournalCard";

const dropdownItems = [
  {
    key: "1",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.antgroup.com"
      >
        1st menu item
      </a>
    ),
  },

  {
    key: "4",
    danger: true,
    label: "a danger item",
  },
];

export default function Journal() {
  return (
    <ContentLayout
      header={
        <>
          <SearchBar />
          <Link
            style={{ width: "100%", maxWidth: "100%" }}
            to="add"
            className="outlet-add btn"
          >
            <CiCirclePlus size={48} />
            <div className="outlet-add-content">
              <h3>Add New Journal</h3>
              <h5 className="disactive">Create New Blog added to Website</h5>
            </div>
          </Link>
          <JournalCard
            imageSrc="/assets/images/dummy/journal.png"
            title="Add New Journal"
            dropdownItems={dropdownItems}
            tags={["Tag1", "Tag2", "Tag3", "Tag4"]}
            date="10/30/2023"
            views={230}
          />
          <JournalCard
            imageSrc="/assets/images/dummy/journal.png"
            title="Add New Journal"
            dropdownItems={dropdownItems}
            tags={["Tag1", "Tag2", "Tag3", "Tag4"]}
            date="10/30/2023"
            views={230}
          />
          <JournalCard
            imageSrc="/assets/images/dummy/journal.png"
            title="Add New Journal"
            dropdownItems={dropdownItems}
            tags={["Tag1", "Tag2", "Tag3", "Tag4"]}
            date="10/30/2023"
            views={230}
          />
          <JournalCard
            imageSrc="/assets/images/dummy/journal.png"
            title="Add New Journal"
            dropdownItems={dropdownItems}
            tags={["Tag1", "Tag2", "Tag3", "Tag4"]}
            date="10/30/2023"
            views={230}
          />
        </>
      }
    ></ContentLayout>
  );
}
